import React, { PropsWithChildren } from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';
import { PageContent } from 'common/styles/page';
import LoadingSpinner from '../LoadingSpinner';

type PageProps = {
  scrollX?: boolean;
  scrollY?: boolean;
  isLoading: boolean;
  error: FetchBaseQueryError | SerializedError | undefined;
  'data-testid'?: string;
} & PropsWithChildren;

/**
 * Page content component which accounts for sidebar and header padding.
 * @param props
 * @constructor
 */
const AsyncPageContent = (props: PageProps) => {
  const { isLoading, error, 'data-testid': testId } = props;

  if (isLoading) {
    return <LoadingSpinner data-testid={testId ? `${testId}-loading` : undefined} />;
  } else if (error) {
    return (
      <PageContent data-testid={testId ? `${testId}-error` : undefined}>
        <p>There was an error fetching data from the api</p>
      </PageContent>
    );
  }

  return (
    <PageContent
      data-testid={testId}
      style={{
        overflowX: props.scrollX ? 'scroll' : 'auto',
        overflowY: props.scrollY ? 'scroll' : 'auto',
      }}
    >
      {props.children}
    </PageContent>
  );
};

export default AsyncPageContent;
